module.exports = [
  {
    constant: true,
    inputs: [],
    name: 'getHubAddr',
    outputs: [{ name: '', type: 'address' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [{ name: 'context', type: 'bytes' }],
    name: 'preRelayedCall',
    outputs: [{ name: '', type: 'bytes32' }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
  {
    constant: true,
    inputs: [
      { name: 'relay', type: 'address' },
      { name: 'from', type: 'address' },
      { name: 'encodedFunction', type: 'bytes' },
      { name: 'transactionFee', type: 'uint256' },
      { name: 'gasPrice', type: 'uint256' },
      { name: 'gasLimit', type: 'uint256' },
      { name: 'nonce', type: 'uint256' },
      { name: 'approvalData', type: 'bytes' },
      { name: 'maxPossibleCharge', type: 'uint256' },
    ],
    name: 'acceptRelayedCall',
    outputs: [{ name: '', type: 'uint256' }, { name: '', type: 'bytes' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: true,
    inputs: [],
    name: 'getRecipientBalance',
    outputs: [{ name: '', type: 'uint256' }],
    payable: false,
    stateMutability: 'view',
    type: 'function',
  },
  {
    constant: false,
    inputs: [
      { name: 'context', type: 'bytes' },
      { name: 'success', type: 'bool' },
      { name: 'actualCharge', type: 'uint256' },
      { name: 'preRetVal', type: 'bytes32' },
    ],
    name: 'postRelayedCall',
    outputs: [],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function',
  },
];
